var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatScreenActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_512_2091)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 11,
    transform: "matrix(-1 0 0 1 23 6.64062)",
    fill: "#7ABEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 20.1406V17.6406V17.1406H19L23 20.6406V20.1406Z",
    fill: "#7ABEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2901 22.3958C23.1301 22.3958 22.9701 22.3358 22.8401 22.2358L18.6601 18.7558C18.5601 18.6758 18.4401 18.6258 18.3101 18.6258H8.24009C7.16009 18.6258 6.28009 17.7458 6.28009 16.6658V13.6058H5.70009C5.57009 13.6058 5.45009 13.6558 5.35009 13.7358L1.17009 17.2158C0.960094 17.3958 0.670094 17.4258 0.420094 17.3158C0.170094 17.1958 0.0100942 16.9558 0.0100942 16.6758V2.86576C9.41586e-05 1.78576 0.880094 0.905762 1.96009 0.905762H15.7601C16.8401 0.905762 17.7201 1.78576 17.7201 2.86576V5.92576H22.0301C23.1101 5.92576 23.9901 6.80576 23.9901 7.88576V21.6858C23.9901 21.9558 23.8301 22.2058 23.5801 22.3258C23.4801 22.3758 23.3801 22.3958 23.2801 22.3958H23.2901ZM7.69009 13.6158V16.6758C7.69009 16.9758 7.94009 17.2258 8.24009 17.2258H18.3101C18.7701 17.2258 19.2101 17.3858 19.5601 17.6758L22.5901 20.1858V7.88576C22.5901 7.58576 22.3401 7.33576 22.0401 7.33576H17.7301V11.6458C17.7301 12.7258 16.8501 13.6058 15.7701 13.6058H7.69009V13.6158ZM1.96009 2.31576C1.66009 2.31576 1.41009 2.56576 1.41009 2.86576V15.1658L4.44009 12.6558C4.79009 12.3658 5.24009 12.2058 5.69009 12.2058H15.7601C16.0601 12.2058 16.3101 11.9558 16.3101 11.6558V2.86576C16.3101 2.56576 16.0601 2.31576 15.7601 2.31576H1.96009Z",
    fill: "#028383"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.64062,
    width: 16,
    height: 11,
    fill: "#028383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 15.1406V12.6406V12.1406H5L1 15.6406V15.1406Z",
    fill: "#028383"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_512_2091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.49,
    fill: "white",
    transform: "translate(0 0.905762)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatScreenActiveIcon);
export default __webpack_public_path__ + "static/media/chatScreenActiveIcon.d9f8cbceb4fab4d2be74e9bfc27124ec.svg";
export { ForwardRef as ReactComponent };